<template>
    <div class="m-dashboard">
        <y-container>
            <y-row>
                <y-col>
                    <y-breadcrumb
                        :items="breadItems"
                        color="disabled"
                        divider="angle-left"
                    />
                </y-col>
            </y-row>
            <y-row>
                <y-col
                    class="m-dashboard__sidebar"
                    md="4"
                >
                    <y-loading
                        :active="$wait.is('fetch-user-info') && $wait.is('fetch-wallets')"
                        height="200px"
                        position="relative"
                    >
                        <y-sidebar
                            type="dashboard"
                            :user="user"
                            :user-metadata="userMetadata"
                            :wallets="wallets"
                            :wallet-charge-button="walletChargeButton"
                            :navigation="$config('dashboard.nav')"
                            size="64px"
                            raised
                        />
                    </y-loading>
                </y-col>

                <y-col
                    xs="12"
                    md="8"
                >
                    <y-back />
                    <router-view
                        :user="user"
                        :user-metadata="userMetadata"
                        :wallets="wallets"
                        @reloadUser="reloadUser"
                    />
                </y-col>
            </y-row>
        </y-container>
    </div>
</template>

<script>
    import PageMixin from '@nodes/mixins/Page';
    import CoreMixin from '@nodes/mixins/Core';
    import YBack from '@modules/dashboard/block/Back/Index.vue';

    import { YBreadcrumb } from '@components';
    import { YSidebar } from '@rogues';

    export default {
        name: 'Dashboard',

        components: {
            YBack,
            YSidebar,
            YBreadcrumb,
        },

        mixins: [
            PageMixin,
            CoreMixin,
        ],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle   : this.$t('dashboard.title'),
                user        : null,
                userMetadata: null,
                wallets     : null,

                walletChargeButton: {
                    label: this.$t('dashboard.sidebar.charge_wallet'),
                    size : 'medium',
                    icon : {
                        name  : 'plus',
                        prefix: 'fa',
                    },
                    link: {
                        name: 'dashboard-charge-wallet',
                    },
                },

                breadItems: [
                    {
                        title: this.$t('home.title'),
                        icon : 'house',
                        route: {
                            name: 'home',
                        },
                    },
                    {
                        title: this.$t('dashboard.title'),
                        route: this.$router,
                    },
                ],
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('dashboard.title'),
            };
        },

        /**
         * @inheritDoc
         */
        created() {
            this.fetchUserInfo();
            this.fetchUserWallets();
        },

        methods: {
            /**
             * Fetch User info
             * 
             * @returns {*}
             */
            fetchUserInfo() {
                this.$wait.start('fetch-user-info');
                return this.$services.Person.userEditProfileFetch().then((response) => {
                    this.user = response.data.results;
                    this.userMetadata = response.data.metadata;
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('fetch-user-info');
                });
            },

            /**
             * Fetch User Wallets
             * 
             * @returns {*}
             */
            fetchUserWallets() {
                this.$wait.start('fetch-wallets');
                return this.$services.Wallet.myWallets().then((response) => {
                    this.wallets = response.data.results;
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('fetch-wallets');
                });
            },

            /**
             * Reload User
             */
            reloadUser() {
                this.fetchUserInfo();
            },
        },
    };
</script>

<style lang="scss" src="../scss/dashboard.scss" />
